module.exports = __webpack_public_path__ + "media/images/homes/Itemmodifiers-f3780de4b7ba5fb7579c862783d431e4.png";